import { styled } from '@mui/material/styles';
import { Box, Paper, Button } from '@mui/material';

// Wrapper box for centering the login form
export const Wrapper = styled(Box)(({ theme, isMobile }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  padding: isMobile ? 0 : theme.spacing(2),
  width: '100%',
}));

// Styled Paper container for the form
export const StyledPaper = styled(Paper)(({ theme, isMobile }) => ({
  padding: theme.spacing(3),
  width: '100%',
  maxWidth: isMobile ? 'none' : '400px',
  height: isMobile ? '100vh' : 'auto',
  display: isMobile ? 'flex' : 'block',
  flexDirection: isMobile ? 'column' : 'row',
  justifyContent: isMobile ? 'center' : 'flex-start',
  borderRadius: isMobile ? 0 : theme.shape.borderRadius,
  boxShadow: isMobile ? 'none' : theme.shadows[3],
  position: 'relative', // Für absolute Positionierung des LanguageSwitchers in Desktop
}));

// Styled form box with top margin
export const FormBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

// Submit button with vertical margins
export const SubmitButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(2),
}));

// Forgot password button with top margin
export const ForgotPasswordButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

// Container for the language switcher positioned in top right
export const LanguageSwitcherContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
  zIndex: theme.zIndex.appBar,
}));
